import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes } from "@emotion/react";
import clsx from "clsx";
import { Box } from "./Box";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { alpha, mergeSx } from "../system";
export const loadingBarClasses = {
    root: "MinervaLoadingBar-root",
};
/**
 * ## Definition
 * A loading bar is a visual indicator that shows an indeterminate progress.
 *
 * ## Behavior
 * - The loading takes the width of its parent container and has a fixed height.
 * - The loading bar is indeterminate and features a pulse animation from the center outwards.
 * - Changing the height is as simple as accessing the `height` property from the `Box` API.
 *
 * ## Structure
 * - Based off of a `Box` component.
 *
 * ## Technical Limitations
 * - Overriding the styles of the loading bar requires accessing the `after` pseudo element and has the potential to break the animation
 */
export const LoadingBar = (props) => {
    const { color = "surface", colorSet, invertColors, sx, className, ...rest } = useDefaultProps({ props, component: "ProgressBar" });
    const indeterminateKeyframe = keyframes `
      0% {
        opacity: 1;
        transform: scaleX(0.0);
      }

      20% {
        opacity: 1;
        transform: scaleX(0.4);
      }

      40% {
        opacity: 1;
        transform: scaleX(0.6);
      }

      60% {
        opacity: 0.75;
        transform: scaleX(0.7);
      }

      80% {
        opacity: 0.25;
        transform: scaleX(0.85);
      }

      100% {
        opacity: 0.0;
        transform: scaleX(1);
      }
    `;
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: ({ background }) => {
            const rootColor = alpha(background, 0.16);
            const edgeColor = alpha(background, 0.01);
            return (_jsx(Box, { width: "100%", height: 1, className: clsx([loadingBarClasses.root, className]), sx: mergeSx({
                    background: rootColor,
                    "&::after": {
                        content: '""',
                        display: "block",
                        height: "100%",
                        background: `linear-gradient(.25turn, ${edgeColor}, ${background}, ${edgeColor})`,
                        animation: `${indeterminateKeyframe} 1.5s linear infinite`,
                    },
                }, sx), ...rest }));
        } }));
};
//# sourceMappingURL=LoadingBar.js.map